import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Activity } from 'lucide-react';

const VolumeCard = ({ stockData }) => {
  const unusual = stockData && stockData.avgVolume && stockData.volume > stockData.avgVolume * 1.5;
  const ratio = stockData?.avgVolume ? (stockData.volume / stockData.avgVolume).toFixed(2) + 'x' : 'N/A';
  return (
    <Card className="hover:shadow-lg transition-shadow" data-testid="research-volume-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Activity className="text-purple-600" size={20} />
          Volume Analysis
        </CardTitle>
      </CardHeader>
      <CardContent>
        {stockData ? (
          <div className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Volume</span>
              <span className="font-medium">
                {stockData.volume ? (stockData.volume / 1e6).toFixed(1) + 'M' : 'N/A'}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Avg Volume</span>
              <span className="font-medium">
                {stockData.avgVolume ? (stockData.avgVolume / 1e6).toFixed(1) + 'M' : 'N/A'}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Volume Ratio</span>
              <Badge variant={unusual ? 'default' : 'outline'} className={unusual ? 'bg-orange-500' : ''}>
                {ratio}
              </Badge>
            </div>
          </div>
        ) : (
          <p className="text-gray-500 text-sm">Search for a stock to see volume data</p>
        )}
      </CardContent>
    </Card>
  );
};

export default VolumeCard;
